<template>
  <b-dropdown-item v-if="visible" href="#" @click.prevent="go"
    >Gestión institucional</b-dropdown-item
  >
</template>

<script>
// Único componente del módulo en el bundle principal. Solo pregunta a /me/ si
// la cuenta es administradora o si ya entró antes al módulo (pista local), y
// nunca deja errores de JS: 401/403/404 se resuelven sin pasar por el catch.
import { state, loadMe, HINT_KEY } from "./state";

export default {
  name: "InstitutionalMenu",
  computed: {
    visible() {
      return (
        state.status === "ok" &&
        !!state.me &&
        Array.isArray(state.me.networks) &&
        state.me.networks.length > 0
      );
    },
  },
  created() {
    try {
      if (state.status !== "idle") return;
      const login = (this.$store && this.$store.state.login) || {};
      if (!login.token) return;
      let hint = false;
      try {
        hint = !!localStorage.getItem(HINT_KEY);
      } catch (e) {
        hint = false;
      }
      if (String(login.isAdmin) === "true" || hint) loadMe();
    } catch (e) {
      // el header lo usan muchas pantallas: nunca romperlo
    }
  },
  methods: {
    go() {
      if (this.$router && this.$router.history.base === "/utopie")
        this.$router.push({ name: "institucional-resumen" }).catch(() => {});
      else window.location.href = "/utopie#/institucional";
    },
  },
};
</script>
